import React, { Fragment } from "react";
import DataTable from "../../Datatable/DataTable";

const TableHolder = ({ cols, heading }) => {
  console.log(cols,heading,"cols and heading")
  return (
    <Fragment>
      {cols.length > 0 ? (
        <DataTable
          data={cols}
          columns={heading}
          paging={true}
          searching={false}
          scrollX={true}
        />
      ) : null}
    </Fragment>
  );
};

export default TableHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Rebalance/section1/tableHolder.jsx